/**
 * Roles and permissions (spec 10 §4): the single source for API and web.
 * Permissions are cut by task; every endpoint declares one and the API checks
 * it on every request against the current membership (REQ-10-016).
 */
export const ROLES = ['admin', 'editor', 'reviewer', 'viewer'];
export const PERMISSIONS = [
    'content:read',
    'media:read',
    'knowledge:read',
    'audit:read',
    'content:write',
    'content:approve',
    'media:write',
    'knowledge:write',
    'calendar:write',
    'publications:write',
    'ai:run',
    'accounts:manage',
    'settings:manage',
    'members:manage',
];
const READ = ['content:read', 'media:read', 'knowledge:read'];
export const ROLE_PERMISSIONS = {
    admin: PERMISSIONS,
    editor: [
        ...READ,
        'content:write',
        'content:approve',
        'media:write',
        'knowledge:write',
        'calendar:write',
        'publications:write',
        'ai:run',
    ],
    reviewer: [...READ, 'content:approve', 'calendar:write'],
    viewer: READ,
};
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
export function permissionsOf(role) {
    return ROLE_PERMISSIONS[role];
}
export function hasPermission(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
/** Commenting has no own permission: writers and approvers may comment (module 50). */
export function canComment(role) {
    return hasPermission(role, 'content:write') || hasPermission(role, 'content:approve');
}
//# sourceMappingURL=permissions.js.map